<template>
 <footer class="bg-gray-900 text-white py-8">
    <div class="container mx-auto text-center">
      <div class="mb-4">
        <h2 class="text-2xl font-bold">Pisu Store</h2>
        <p class="mt-2">Tu tienda peruana de e-sports</p>
      </div>
      <div class="flex justify-center items-center space-x-6 mb-4">
        <a href="mailto:shop@pisustore.com" class="flex items-center space-x-2 hover:text-gray-400">
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12.713l11.985-7.713H.015L12 12.713zm0 2.574L.015 7.287v11.426L12 15.287zm0 0l11.985 3.426V7.287L12 15.287z"/>
          </svg>
          <span>shop@pisustore.com</span>
        </a>
        <a href="tel:+51949234215" class="flex items-center space-x-2 hover:text-gray-400">
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.5 1.5 0 011.6-.33c1.1.44 2.3.67 3.53.67a1.5 1.5 0 011.5 1.5v3.5a1.5 1.5 0 01-1.5 1.5C10.29 24 0 13.71 0 1.5A1.5 1.5 0 011.5 0h3.5a1.5 1.5 0 011.5 1.5c0 1.23.23 2.43.67 3.53a1.5 1.5 0 01-.33 1.6l-2.2 2.2z"/>
          </svg>
          <span>+51 949234215</span>
        </a>
        <a href="https://www.facebook.com/profile.php?id=61570411208749" target="_blank" class="flex items-center space-x-2 text-blue-500 hover:text-blue-700">
          <svg height="32" width="32" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
              viewBox="0 0 291.319 291.319" xml:space="preserve">
            <g>
              <path style="fill:#3B5998;" d="M145.659,0c80.45,0,145.66,65.219,145.66,145.66c0,80.45-65.21,145.659-145.66,145.659
                S0,226.109,0,145.66C0,65.219,65.21,0,145.659,0z"/>
              <path style="fill:#FFFFFF;" d="M163.394,100.277h18.772v-27.73h-22.067v0.1c-26.738,0.947-32.218,15.977-32.701,31.763h-0.055
                v13.847h-18.207v27.156h18.207v72.793h27.439v-72.793h22.477l4.342-27.156h-26.81v-8.366
                C154.791,104.556,158.341,100.277,163.394,100.277z"/>
            </g>
            </svg>
        </a>
      </div>
      <p class="text-sm text-gray-500">&copy; 2024 Pisu Store. Todos los derechos reservados.</p>
    </div>
  </footer>
  </template>
  
  <script>
  export default {
    name: 'FooterComponent'
  }
  </script>
  
  <style scoped>
  /* Puedes agregar estilos adicionales aquí si es necesario */
  </style>